import classNames from "classnames";
import PropTypes from "prop-types";
import React from "react";
import _ from "underscore";
import Columns from "../common/Columns";
import OutcomesTable from "../outcomes/OutcomesTable";
import SectionContent from "../section/SectionContent";
import SectionTitle from "../section/SectionTitle";
import SectionImage from "../section/SectionImage";
import TextContent from "../common/TextContent";
import { textContentPropType, questionPropType } from "../../lib/dataShapes";
import styles from "../../styles/content.module.scss";

const Subchapter = ({ className, question, subchapter }) => {
  const { content, title, titleHidden, type } = subchapter;
  const sectionClassnames = classNames(styles.sectionContent, {
    [styles.sectionWithImage]: !_.isEmpty(subchapter.illustration),
    [styles.sectionWithBorder]: _.isEmpty(subchapter.illustration)
  });

  if (type === "editor" && _.isEmpty(content)) return null;
  if (type === "table" && _.isEmpty(subchapter.tableContent)) return null;
  if (type === "outcomesTable" && _.isEmpty(question.outcomes)) return null;

  return (
    <div className={classNames(styles.section, className)}>
      {!titleHidden && <SectionTitle title={title} />}
      {type !== "outcomesTable" && (
        <SectionContent>
          <div className={sectionClassnames}>
            {!_.isEmpty(subchapter.illustration) && (
              <SectionImage image={subchapter.illustration} />
            )}
            {type === "editor" && <TextContent content={content} />}
            {type === "table" && !_.isEmpty(subchapter.tableContent) && (
              <Columns columns={subchapter.tableContent.columns} />
            )}
          </div>
        </SectionContent>
      )}
      {type === "outcomesTable" && (
        <OutcomesTable
          intervention={question.intervention}
          comparison={question.comparison}
          outcomes={question.outcomes}
          explanations={question.explanations}
        />
      )}
    </div>
  );
};

Subchapter.propTypes = {
  subchapter: PropTypes.shape({
    content: textContentPropType,
    tableContent: PropTypes.shape({
      columns: PropTypes.arrayOf(
        PropTypes.shape({
          header: PropTypes.string.isRequired,
          content: textContentPropType,
          illustration: PropTypes.shape({
            illustration: PropTypes.string.isRequired,
            customSrc: PropTypes.string
          })
        })
      )
    }),
    title: PropTypes.string.isRequired,
    titleHidden: PropTypes.bool.isRequired,
    type: PropTypes.oneOf(["editor", "table", "outcomesTable"]).isRequired,
    image: PropTypes.any
  }).isRequired,
  question: PropTypes.shape(questionPropType)
};

export default Subchapter;
